import React from 'react';
import './FloodErosion.scss'; // Import the CSS file for styling

const formatType = (type) => {
  if (!type || typeof type !== 'string') return '';

  // Convert camelCase or any other format to words with spaces and capitalize each word
  const formattedType = type
    .replace(/([a-z])([A-Z])/g, '$1 $2') // Add space between camel case words
    .replace(/[_-]/g, ' ') // Replace underscores and hyphens with spaces
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word

  return formattedType;
};

const FloodErosion = ({ floodErosion }) => {
  return (
    <div className="flood-erosion-info-wrap">
      {floodErosion && 
        <h6 className="flood-erosion-info-title">Flood & Erosion</h6>
      }
      <ul className="flood-erosion-listing">
        {floodErosion?.floodedInLastFiveYears && (
          <li>
            <p className="flood-erosion-title">Flooded In Last Five Years?</p>
            <p className="flood-erosion-value">{floodErosion?.floodedInLastFiveYears ? 'Yes':'No'}</p>
          </li>
        )}
        {floodErosion?.floodDefences && (
          <li>
            <p className="flood-erosion-title">Flood Defences Available?</p>
            <p className="flood-erosion-value">{floodErosion?.floodDefences}</p>
          </li>
        )}
        {floodErosion?.floodSources?.length > 0 && (
          <li>
            <p className="flood-erosion-title">Flood Sources:</p>
            <p className="flood-erosion-value">
              {floodErosion?.floodSources.map(formatType).join(', ')}
            </p>
          </li>
        )}
        {floodErosion?.lastFlood && (
          <li>
            <p className="flood-erosion-title">Last Flood Date:</p>
            <p className="flood-erosion-value">{floodErosion?.lastFlood}</p>
          </li>
        )}        
      </ul>
    </div>
  );
};

export default FloodErosion;